import { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { useCookies } from 'react-cookie';
import QRCode from "react-qr-code";
import { toast } from 'react-toastify';

import { APIURI, APIKEY } from '../config';

export default function Portal() {

    const [sessionId, setSessionId] = useState(null);

    const navigate = useNavigate();

    const [cookies, setCookie] = useCookies(['cookies']);


    async function generateNewSession() {
        console.log("generateNewSession");

        let sessionInitiator = "AUTH_PORTAL_TEST";

        let url = APIURI + '/session/create';
        let data = {
            sessionInitiator: sessionInitiator,
            APIKey: APIKEY
        }

        try {
            const response = await fetch(url, {
                method: "POST",
                mode: "cors",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(data),
            });

            if (!response.ok) {
                return;
            } else {
                const result = await response.json();
                setSessionId(result.data.sessionId);
                toast.success("Session generated successfully. Authenticate it in your app now.");
                return;
            }
        } catch (e) {
            console.error(e);
            return;
        }
    }

    useEffect(() => {
        console.log("sessionId change", sessionId);

        if (sessionId === undefined || sessionId === null) {
            return;
        }

        let sessionInterval = setInterval(async () => {
            console.log("sessionInterval", sessionId);

            if (sessionId === undefined || sessionId === null) {
                return;
            }

            let data = {
                sessionId: sessionId,
                APIKey: APIKEY
            }
            let params = new URLSearchParams(data).toString();
            let url = APIURI + '/session?' + params;

            try {

                const response = await fetch(url, {
                    method: "GET",
                    mode: "cors",
                    headers: {
                        "Content-Type": "application/json",
                    }
                });
                
                if (!response.ok) {
                    return;
                } else {
                    const result = await response.json();
                    if (result.data.sessionSignature !== '' && result.data.sessionSignature !== null) {
                        setCookie('phenixSession', result.data.sessionId, { path: '/' });
                        setCookie('phenixSignature', result.data.sessionSignature, { path: '/' });
                        toast.success("Session authenticated successfully");
                        navigate('/rewards');
                        clearInterval(sessionInterval);
                        return;
                    }
                }
            } catch (e) {
                toast.error(e);
            }
        }, 5000);
    }, [sessionId]);

    async function validateSessionClick() {
        var ua = navigator.userAgent.toLowerCase();
        var isAndroid = ua.indexOf("android") > -1; // Check if user is using an Android device
        
        if(isAndroid) {
            // If it's an Android device, try to open your app using the custom URL scheme
            window.location.href = 'phenix.auth.popup://sessionId=' + sessionId;
        
            // If the app is not installed, redirect to the Play Store
            setTimeout(function() {
                window.location.href = 'https://play.google.com/store/apps/details?id=phenix.phenixauthentication';
            }, 1000);
        }

    }

    return (
        <>
            <div className="page-wrapper">
                <div className="content-wrapper">
                    <h1>Auth Portal Demo</h1>
                    <p>
                        In this demo, you can generate sessions for the Phenix authentication app.
                    </p>
                    <br />
                    <button className="btn-primary" disabled={sessionId !== null} onClick={generateNewSession}>Generate Session</button>
                    <br /><br />
                    {
                        (sessionId !== null) ? (
                            <div className="session-wrapper">
                                Session details:<br />
                                <QRCode value={sessionId} size={200} />
                                <br />
                                <a href={"phenix.auth.popup://open?sessionId=" + sessionId} className="btn-secondary" style={{fontSize: "14px"}}>Open in app</a>
                            </div>
                        ) : null
                    }
                </div>
            </div>
            <footer>&copy; Copyright 2024 Finnovant</footer>
        </>
    );

}
